import { render, staticRenderFns } from "./AnteprimaModal.vue?vue&type=template&id=2a729143&"
import script from "./AnteprimaModal.vue?vue&type=script&lang=js&"
export * from "./AnteprimaModal.vue?vue&type=script&lang=js&"
import style0 from "./AnteprimaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports